import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ModalComp } from "../../components";
import { useAppDispatch } from "../../redux/Hooks/Hook";
import { AllSportsList } from "../../redux/Slice/Sports/SportsListSlice";
import { DeleteSport } from "../../utilities/api/sports/indext";

const ArchiveSport = ({ archive, setArchive, id }: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [message, setMessage] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  useEffect(() => {
    if (!archive) {
      setMessage("");
    }
    return () => {
      setMessage("");
    };
  }, [archive]);
  const handleDelete = async () => {
    if (isDeleting) return
    setIsDeleting(true)
    const result = await DeleteSport(id);
    if (result?.status === 200) {
      setArchive(false);
      navigate("/sports");
      dispatch(AllSportsList({}));
    }
    if (result?.response?.status) {
      setMessage(result.response.data.message);
    }
    setIsDeleting(false)
  };
  return (
    <ModalComp
      archive={archive}
      setArchive={setArchive}
      handleDelete={handleDelete}
      message={message}
      isDeleting={isDeleting}
    />
  );
};

export { ArchiveSport };
